import { ContentCard as BaseContentCard } from '~/components/media/card';
import { useLink } from '~/hooks/link';
import { useLocation } from '~/hooks/location';
import type {
  ContentFolderView__ContentItem,
  ContentFolderView__MediaItem,
} from '../ContentFolderView.generated';
import { ContentMenu } from './ContentMenu';

/* GraphQL */ `#graphql
fragment ContentCardProps__ContentItem on ContentItem {
  design {
    designFolderId
    id
  }
  id
  name
  nullableContentFolderId: contentFolderId
  overlay {
    id
    duration
  }
  tags
  thumbnailUri
  updatedAt
  createdAt
}
fragment ContentCardProps__MediaItem on MediaItem {
  contentFolderId
  contentItemCount
  designCount
  id
  kind
  name
  originalFile {
    downloadUri
    uri
    originalFilename
  }
  originalMetadata
  overlay {
    id
    duration
  }
  tags
  thumbnailUri
  updatedAt
  createdAt
}
`;

const useItemLink = (item: ContentFolderView__ContentItem | ContentFolderView__MediaItem) => {
  const link = useLink();

  if (item.__typename === 'ContentItem' && item.design?.id) {
    return link(`/studio/${item.design.designFolderId}/design/${item.design.id}`);
  }

  const contentFolderId =
    item.__typename === 'ContentItem' ? item.nullableContentFolderId : item.contentFolderId;
  return link(
    `/content/${contentFolderId}/${item.__typename === 'ContentItem' ? 'apps' : 'media'}/${
      item.id
    }/${item.__typename === 'ContentItem' ? 'settings' : 'details'}`,
  );
};

export interface ContentCardProps {
  item: ContentFolderView__ContentItem | ContentFolderView__MediaItem;
  selected: boolean;
}

export const ContentCard = ({ item, selected }: ContentCardProps) => {
  const to = useItemLink(item);
  const location = useLocation();
  return (
    <BaseContentCard
      LinkProps={{
        color: 'inherit',
        to,
        state: { returnTo: location.fullPath },
      }}
      item={item}
      checked={selected}
    >
      <ContentMenu item={item} />
    </BaseContentCard>
  );
};
